<script lang="ts">
  import { createInfiniteQuery, useQueryClient } from '@tanstack/svelte-query';
  import { RANKED_TIERS, TIER_POINTS, TOP_TIER } from '../../shared/ranked';
  import { ladderQueryOptions, ladderRows, refreshLadder } from '../queries/ranked';
  import PagedList from './PagedList.svelte';

  /** The Competitive rank ladder: placed players by tier, then points. */
  interface Props {
    credential: string | null;
    profileGeneration: number;
  }
  let { credential, profileGeneration }: Props = $props();

  const queryClient = useQueryClient();
  const query = createInfiniteQuery(() => ladderQueryOptions(credential, profileGeneration));
  const rows = $derived(ladderRows(query.data));
  const error = $derived(query.error?.message ?? '');

  function refresh(): void {
    void refreshLadder(queryClient, credential, profileGeneration).catch(() => undefined);
  }
</script>

<PagedList
  {error}
  loading={query.isPending && !query.data}
  loadingMessage="Loading ranks…"
  empty={!query.isPending && !error && !rows.length}
  emptyMessage="Nobody has finished placement yet."
  fetching={query.isFetching}
  fetchingNextPage={query.isFetchingNextPage}
  hasNextPage={query.hasNextPage}
  moreLabel="More Ranks"
  {refresh}
  more={() => void query.fetchNextPage()}
>
  <ol class="leaderboard" aria-label="Competitive ranks">
    {#each rows as row, index (row.profileId)}
      <li class="lb">
        <div class="lb-head">
          <span class="lb-rank">{index + 1}</span><span class="lb-av">{row.avatar}</span><span class="lb-name"
            >{row.name}<small
              >{RANKED_TIERS[row.tier]} · {row.wins}–{row.losses}{row.draws ? `–${row.draws}` : ''}</small
            ></span
          ><span class="lb-score"
            >{row.points}<small>{row.tier === TOP_TIER ? 'pts' : `/ ${TIER_POINTS}`}</small></span
          >
        </div>
      </li>
    {/each}
  </ol>
</PagedList>
